const FileAvisoIcon = ({ width = 24, height = 24, color = "#111" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} color={color} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /></svg>
    )
}

export default FileAvisoIcon